// @ts-expect-error Untyped module
import { catchAndRethrowNetworkError } from 'crm_data/bCommerce/monitoring/errorUtils';
import { withPaymentsClient } from './clients';
export const fetchTransactionLimits = withPaymentsClient((client, {
  portalId,
  currency
}) => {
  return client.get(`payments-checkout/v1/checkout-sessions/by-portal/${portalId}/limits?currency=${currency}`).catch(catchAndRethrowNetworkError);
});